import * as React from "react";
import { Typography } from "@mui/material";
import { constNull, pipe } from "fp-ts/function";
import { LocalDate } from "../common/date/LocalDate";
import { array, nonEmptyArray, option } from "fp-ts";
import { EventDetail } from "../../hooks/event";

type Props = Pick<EventDetail, "title" | "date" | "location">;

export const EventTitle = (p: Props) => {
    return (
        <>
            <Typography variant={"h4"} component={"h1"}>
                {p.title}
            </Typography>
            {pipe(
                [
                    p.date == null ? null : (
                        <LocalDate key={"date"} date={p.date} />
                    ),
                    p.location == null ? null : (
                        <span key={"location"}>{p.location}</span>
                    ),
                ],
                array.filterMap(option.fromNullable),
                nonEmptyArray.fromArray,
                option.map(
                    nonEmptyArray.intersperse(<span key={"joiner"}>, </span>)
                ),
                option.fold(constNull, (segments) => (
                    <Typography variant={"h6"} component={"p"}>
                        {segments}
                    </Typography>
                ))
            )}
        </>
    );
};
